import React from 'react'
import { StripeProvider, Elements } from 'react-stripe-elements'
import StripeCheckoutForm from './StripeCheckoutForm'


function Checkout({auth, developers, cost, tokensBought}) {
    return (
    <StripeProvider apiKey="pk_live_51IQM49DGIrW588V8peopeSILQL0Dh4Bzpv9jSadT1UvsP01cyG9UbSCFqoWMplVSbl1TE6P7pcwSrLTuGKrUTNhO00ptV0a3vv">
        <Elements>
            <StripeCheckoutForm auth={auth} developers={developers} cost={cost} tokensBought={tokensBought}/>
        </Elements>
    </StripeProvider>
    )
}

export default Checkout
